import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-yes-no',
  templateUrl: './dialog-yes-no.component.html',
  styleUrls: ['./dialog-yes-no.component.scss'],
})
export class DialogYesNoComponent implements OnInit {
  loading = false;

  constructor(public dialogRef: MatDialogRef<DialogYesNoComponent>, @Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit(): void {}

  closeDialog(data?: any) {
    this.dialogRef.close(data);
  }

  confirm() {
    this.closeDialog({ continue: true });
  }
}
